/* eslint-disable react/no-multi-comp */
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import {
  Drawer,
  List,
  ListSubheader,
  Divider,
  Button,
  ButtonGroup,
  Typography,
  Box,
} from "@mui/material";
import { setCurrentType } from "slices/currentTypeSlice";

import { useLocation, useNavigate } from "react-router-dom";
import { useTheme } from "@emotion/react";
import DevicesContent from "./navbarComponents/devicesContent";
import AssembliesContent from "./navbarComponents/assembliesContent";

function NavBar({ openMobile, onMobileClose, className }) {
  const location = useLocation();
  const navigate = useNavigate();
  const theme = useTheme();
  const dispatch = useDispatch();
  const [btnStyleType, setBtnStyleType] = useState(0);

  const [deviceFilterState, setDeviceFilterState] = useState({
    assemblyStatus: null,
    calibrationStatus: null,
    startDate: null,
    endDate: null,
    deviceType: null,
  });
  const [assemblyFilterState, setAssemblyFilterState] = useState({
    assemblyStatus: null,
    oadUpdateStatus: null,
    startDate: null,
    endDate: null,
    pcbType: null,
  });
  const currentType = useSelector(
    (state) => state.currentTypeState.currentType
  );

  useEffect(() => {
    if (openMobile && onMobileClose) {
      onMobileClose();
    }

    // eslint-disable-next-line
  }, []); //??

  useEffect(() => {
    if (location.pathname.includes("assemblies")) {
      dispatch(setCurrentType("ASSEMBLIES"));
      setBtnStyleType(1);
    } else {
      dispatch(setCurrentType("DEVICES"));
      setBtnStyleType(0);
    }
  }, [setCurrentType]);

  const handleChangeType = (type) => {
    if (type === "DEVICES") {
      setBtnStyleType(0);
      navigate("/main/devices/Information");
      window.location.reload(false);
    } else {
      setBtnStyleType(1);
      navigate("/main/assemblies/Information");
      window.location.reload(false);
    }
    dispatch(setCurrentType(type));

    setAssemblyFilterState({
      ...assemblyFilterState,
      assemblyStatus: null,
      oadUpdateStatus: null,
      startDate: null,
      endDate: null,
    });

    setDeviceFilterState({
      ...deviceFilterState,
      assemblyStatus: null,
      calibrationStatus: null,
      startDate: null,
      endDate: null,
    });
  };

  const content = (
    <Box sx={{ height: "100%", display: "flex", flexDirection: "column" }}>
      <Box
        component="nav"
        sx={{
          overflow: "auto",
          padding: theme.spacing(0, 2, 2, 2),
          flexGrow: 1,
        }}
      >
        <List>
          <ListSubheader disableSticky>
            {currentType === "DEVICES" ? (
              <DevicesContent
                openMobile={openMobile}
                onMobileClose={onMobileClose}
              />
            ) : (
              <AssembliesContent
                openMobile={openMobile}
                onMobileClose={onMobileClose}
              />
            )}
          </ListSubheader>
        </List>
      </Box>
      <Typography
        sx={{ margin: theme.spacing(0, 2, 1, 2), textAlign: "center" }}
        variant="h5"
      >
        {"Version: 1.2.2"} {/* TODO Replace this with enviroment variable */}
      </Typography>
    </Box>
  );

  return (
    <Drawer
      anchor="left"
      sx={{ width: 32, mt: 8, pt: 8 }}
      open
      variant="persistent"
    >
      <Box
        component="nav"
        sx={{
          overflow: "hidden",
          margin: theme.spacing(1),
          padding: theme.spacing(0, 2, 2, 2),
          "& > *": {
            margin: theme.spacing(1),
          },
          flexGrow: 1,
          paddingTop: "64px",
        }}
      >
        <Typography variant="h6" gutterBottom style={{ margin: "10px 0" }}>
          Types
        </Typography>
        <ButtonGroup
          size="small"
          variant="contained"
          aria-label="outlined small button group"
        >
          <Button
            children="DEVICES"
            color={btnStyleType === 0 ? "primary" : ""}
            onClick={() => {
              handleChangeType("DEVICES");
            }}
          />
          <Button
            children="ASSEMBLIES"
            color={btnStyleType === 1 ? "primary" : ""}
            onClick={() => {
              handleChangeType("ASSEMBLIES");
            }}
          />
        </ButtonGroup>
      </Box>
      <Divider variant="middle" />
      {content}
    </Drawer>
  );
}

NavBar.propTypes = {
  className: PropTypes.string,
  onMobileClose: PropTypes.func,
  openMobile: PropTypes.bool,
};

export default NavBar;
